import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=295e3841&"
import script from "./ThemeEditor.vue?vue&type=script&lang=js&"
export * from "./ThemeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports